<div id="conversion-breakdownpanel" class="breakdown-panel">
  <div class="form-group">
    <label for="startObject">Start object</label>
    <input id="startObject" autocomplete="off" type="text" class="form-control"
      [(ngModel)]="startobject" (ngModelChange)="setStartObject($event)" aria-describedby="analysisSettingsHelp" />
  </div>
  <fieldset class="breakdown-validity">
    <legend class="sr-only">Time validity</legend>
    <label class="breakdown-validity__option" for="inclTimeValidity">
      <input type="checkbox" id="inclTimeValidity" [(ngModel)]="timeValidity" (ngModelChange)="setTimeValidity(timeValidity)" />
      <span>Include preliminary COs</span>
    </label>
  </fieldset>
  <p id="analysisSettingsHelp" class="analysis-settings-help">These settings apply to analysis. The preliminary CO setting also applies to execution choices. They are not saved with the provision.</p>
</div>
